/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  height?: number;
  width?: number;
  style?: React.CSSProperties;
};

// This component exists so that we can have a CUI-like counterpart for the CDS dialogue item in ItemIcon.tsx
// As of 03/26/2025, CUI item icons are still used in `AutoNextOverlay` and `AddSharedItemSelectionOption`
// Once those components are updated to use CDS icons, we can remove this component
// ticket: https://coursera.atlassian.net/browse/HOL-5225
const DialogueIcon = (props: Props) => {
  const { height = 24, width = 24, style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill="var(--cds-color-neutral-primary)"
      style={style}
    >
      <path d="M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z" />
    </svg>
  );
};

export default DialogueIcon;
